import styled from '@emotion/styled';
import HighlightOffOutlinedIcon from '@portalterreno/react-ui-icons/HighlightOffOutlinedIcon';

const ErrorIcon = styled(HighlightOffOutlinedIcon)(
  {
    width: 66,
    height: 66
  },
  ({ theme }) => ({
    color: theme.palette.primary
  })
);

export default ErrorIcon;
